import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { withTranslation } from 'react-i18next';
import ButtonGroup from './widgets/button-group';
import ButtonItem from './widgets/button-item';
import DropList from './widgets/drop-list';
var InsertTable = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(InsertTable, _React$PureComponent);
  var _super = _createSuper(InsertTable);
  function InsertTable() {
    _classCallCheck(this, InsertTable);
    return _super.apply(this, arguments);
  }
  _createClass(InsertTable, [{
    key: "render",
    value: function render() {
      var _this = this;
      return /*#__PURE__*/React.createElement(ButtonGroup, {
        className: 'editor-btn-group'
      }, /*#__PURE__*/React.createElement(DropList, {
        icon: 'iconfont icon-left-alignment',
        items: [{
          handle: function handle(e) {
            _this.props.onSetAlign(e, 'left');
          },
          icon: 'iconfont icon-left-alignment',
          text: this.props.t('left')
        }, {
          handle: function handle(e) {
            _this.props.onSetAlign(e, 'center');
          },
          icon: 'iconfont icon-center-horizontally',
          text: this.props.t('center')
        }, {
          handle: function handle(e) {
            _this.props.onSetAlign(e, 'right');
          },
          icon: 'icon icon-align-right',
          text: this.props.t('right')
        }]
      }), /*#__PURE__*/React.createElement(DropList, {
        icon: 'iconfont icon-column',
        items: [{
          handle: this.props.onInsertColumn,
          text: this.props.t('Insert_Column')
        }, {
          handle: this.props.onRemoveColumn,
          text: this.props.t('Remove_Column')
        }]
      }), /*#__PURE__*/React.createElement(DropList, {
        icon: 'iconfont icon-row',
        items: [{
          handle: this.props.onInsertRow,
          text: this.props.t('Insert_Row')
        }, {
          handle: this.props.onRemoveRow,
          text: this.props.t('Remove_Row')
        }]
      }), /*#__PURE__*/React.createElement(ButtonItem, {
        disabled: false,
        isRichEditor: true,
        text: this.props.t('remove_table'),
        id: 'removeTable',
        icon: 'iconfont icon-delete-table',
        onMouseDown: this.props.onRemoveTable
      }));
    }
  }]);
  return InsertTable;
}(React.PureComponent);
export default withTranslation('seafile-editor')(InsertTable);